export enum RecordStatus {
  Active = 1,
  Inactive = 0,
  Expired = 7,
  InQueue = 8,
  Deleted = 9,
}
